import React, { useState, useEffect } from "react";
import "../../../styles/Resizable.css";
import { ResizableBox } from "react-resizable";

const TypographyVerticalDisplay = ({ inputs, size, currentFont, setTypeSizeTags }) => {
  const [finalValues, setFinalValues] = useState([]);

  useEffect(() => {
    setTypeSizeTags(finalValues);
  }, [finalValues]);

  function evenRound(decimalValue) {
    return 2 * Math.round(decimalValue / 2);
  }

  const baseFontSize = inputs["Base Font Size"] || 16;
  const modularScale = inputs["Modular Scale"] || 1.25;

  const baseDisplaySizes = [
    { id: 1, label: "XS", fontSize: evenRound(baseFontSize / modularScale) },
    { id: 2, label: "S", fontSize: evenRound(baseFontSize) * Math.pow(modularScale, 0) },
    { id: 3, label: "M", fontSize: evenRound(baseFontSize * Math.pow(modularScale, 1)) },
    { id: 4, label: "L", fontSize: evenRound(baseFontSize * Math.pow(modularScale, 2)) },
    { id: 5, label: "XL", fontSize: evenRound(baseFontSize * Math.pow(modularScale, 3)) },
    { id: 6, label: "XXL", fontSize: evenRound(baseFontSize * Math.pow(modularScale, 4)) },
  ];

  function calcLineHeight(displaySizes, inputLineHeight) {
    return displaySizes.map((displaySize) => {
      const lineHeight = Math.ceil((displaySize.fontSize * inputLineHeight) / 8) * 8;
      return { ...displaySize, lineHeight: lineHeight };
    });
  }

  useEffect(() => {
    setFinalValues([
      ...calcLineHeight(baseDisplaySizes.slice(0, 3), inputs["XS-M Line Height"]),
      ...calcLineHeight(baseDisplaySizes.slice(3, 6), inputs["L-XXL Line Height"]),
    ]);
  }, [inputs]);

  function renderTextDisplay() {
    const sortedVals = finalValues.sort(function (a, b) {
      return b.id - a.id;
    });

    return sortedVals.map((item) => {
      return (
        <div className="text-display-container">
          <div className="text-display-label">{item.label}</div>
          <div className="text-display">
            <p
              className="text-preview"
              style={{
                fontSize: item.fontSize,
                lineHeight: item.lineHeight + "px",
                fontFamily: currentFont,
                // top: Math.ceil((item.fontSize - item.lineHeight) / 16) * 8,
              }}>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit
            </p>
          </div>
        </div>
      );
    });
  }

  return (
    <ResizableBox
      // className="typography-vertical-display-container"
      width={size.sizeEnd > 9000 ? size.sizeStart : size.sizeEnd}
      axis={"x"}
      resizeHandles={["ne"]}
      handleSize={[30, 30]}
      minConstraints={[size.sizeStart < 250 ? 250 : size.sizeStart]}
      maxConstraints={[size.sizeEnd]}>
      <div className="typography-vertical-display-header">
        <div className="typography-vertical-display-header-label">{size.label}</div>
        <div className="typography-vertical-display-header-sublabel">
          {size.sizeStart} - {size.sizeEnd}px
        </div>
      </div>
      <div className="typography-vertical-display">{renderTextDisplay()}</div>
    </ResizableBox>
  );
};

export default TypographyVerticalDisplay;
